// removed by extract-text-webpack-plugin
module.exports = {"component":"_1lbXL0YgRXDDae6s68yGkr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Mobile/OneClickBuy/CreditCard/creditCard.css
// module id = 1230
// module chunks = 2